import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getApiData } from '../helpers/AxiosInstance';

interface IUseGetHook {
  queryKey: (string | number)[];
  url: string;
  params: any;
  interval?: number;
}

const useGetHook = (props: IUseGetHook) => {  
  const { queryKey, url, params, interval } = props;
  const { isLoading, isError, data, isSuccess, refetch, isRefetching } =
    useQuery({
      queryKey: [...queryKey, params.type, params.limit, params.offset],
      queryFn: async () => {
        const response = await getApiData(url, params);
        return response.data;
      },
      refetchOnWindowFocus: true,
      refetchInterval: interval ?? false,
      refetchIntervalInBackground: false,
      placeholderData: keepPreviousData,
    });
  return { isLoading, isError, data, isSuccess, refetch, isRefetching };
};

export default useGetHook;
